import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from '../layout/main-layout/main-layout.component';
import { ProductsComponent } from './products.component';
import { Layouts } from '../app.component'
import { MaintainProductComponent } from './maintain-products/maintain-product.component';
import { ListProductComponent } from './list-products/list-products.component';
import { StockCountComponent } from './stock-count/stock-count.component';
import { StockCountBatchComponent } from './stock-count-batch/stock-count-batch.component';

const routes: Routes = [
  {
    path: 'products',
    component: ProductsComponent,
    data: { layout: Layouts.Main }
  },
  {
    path: 'products/create',
    component: MaintainProductComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'products/list',
    component: ListProductComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'products/stockcount',
    component: StockCountComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'products/stockcountbatch',
    component: StockCountBatchComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'productcreate/:id',
    component: MaintainProductComponent,
    data: { layout: Layouts.Main 
    }
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule { }
